import {PurchaseOrderItemStatusType} from "../../api/Constants";
import {Tag} from "antd";

export const PurchaseOrderItemStatusTag = ({item, props}) => {
    let tagColor = "#108ee9";
    // let popOverContent;
    switch (item.state) {
        case PurchaseOrderItemStatusType.Requested:
            tagColor = "#108ee9";
            // popOverContent = `Item is Newly Requested.  Set to In-Progress when work has begun`;
            break;
        case PurchaseOrderItemStatusType.InProgress:
            tagColor = "#f55442";
            // popOverContent = `Work is in-progress.  Set to Complete when work is finished`
            break;
        case PurchaseOrderItemStatusType.Complete:
            tagColor = "#0ea133";
            // popOverContent = `Work is Completed.  Set to Verified when item is verified in inventory`
            break;
        case PurchaseOrderItemStatusType.Verified:
            tagColor = "#8f8f8f";
            // popOverContent = `Work is Verified.`
            break;
        default:
    }

    return <Tag color={tagColor}>{PurchaseOrderItemStatusType.Label[item.state]}</Tag>
}